import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ScrollText, ExternalLink, Handshake, Scale, Sparkles } from 'lucide-react'

const termsFacts = [
  { icon: Handshake, text: 'Fair play rules' },
  { icon: Scale, text: 'Your rights explained' },
  { icon: Sparkles, text: 'No lawyer speak' },
]

export default function TermsPage() {
  const [countdown, setCountdown] = useState(5)
  const [hovering, setHovering] = useState(false)

  useEffect(() => {
    if (hovering) return
    
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          window.location.href = 'https://thepromisedclan.com/terms'
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [hovering])

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-950 to-indigo-900 text-slate-50 flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        <div className="bg-slate-900/70 border border-slate-800 rounded-2xl p-8 shadow-2xl shadow-indigo-900/40 text-center space-y-6">
          {/* Animated scroll icon */}
          <div className="relative mx-auto w-20 h-20">
            <div className="absolute inset-0 bg-indigo-500/20 rounded-full animate-ping" />
            <div className="absolute inset-2 bg-indigo-500/30 rounded-full animate-pulse" />
            <div className="relative flex items-center justify-center w-full h-full bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-full shadow-lg shadow-indigo-900/50">
              <ScrollText className="w-10 h-10 text-white" />
            </div>
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-slate-50">Terms of Service</h1>
            <p className="text-slate-200/80">
              Taking you to The Promised Clan's terms — the legal home of CIPHERGRID.
            </p>
          </div>

          {/* Fun facts */}
          <div className="grid grid-cols-3 gap-3">
            {termsFacts.map(({ icon: Icon, text }) => (
              <div
                key={text}
                className="bg-slate-800/50 rounded-lg p-3 space-y-2 border border-slate-700/50"
              >
                <Icon className="w-5 h-5 mx-auto text-indigo-400" />
                <p className="text-xs text-slate-300">{text}</p>
              </div>
            ))}
          </div>

          {/* Countdown / Action */}
          <div className="space-y-4">
            <div
              className="relative h-2 bg-slate-800 rounded-full overflow-hidden"
              onMouseEnter={() => setHovering(true)}
              onMouseLeave={() => setHovering(false)}
            >
              <div
                className="absolute inset-y-0 left-0 bg-gradient-to-r from-indigo-500 to-indigo-400 transition-all duration-1000 ease-linear"
                style={{ width: `${((5 - countdown) / 5) * 100}%` }}
              />
            </div>

            <p className="text-sm text-slate-300">
              {hovering ? (
                <span className="text-indigo-300">Paused — take your time</span>
              ) : (
                <>
                  Redirecting in <span className="font-mono text-indigo-300">{countdown}</span> seconds
                </>
              )}
            </p>

            <a
              href="https://thepromisedclan.com/terms"
              className="inline-flex items-center gap-2 px-6 py-3 bg-indigo-500 hover:bg-indigo-400 text-slate-900 font-semibold rounded-lg transition shadow-lg shadow-indigo-900/40"
            >
              Go now
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>

          <Link
            to="/"
            className="inline-block text-sm text-slate-400 hover:text-indigo-300 transition"
          >
            ← Back to CIPHERGRID
          </Link>
        </div>
      </div>
    </div>
  )
}
